import { type ReactNode } from 'react';

export enum SYSTEM_CATEGORY_TAB {
  DEPARTMENT = 'department',
  POSITION = 'position',
}

export enum UTILITY_MANAGEMENT_TAB {
  WORK_SCHEDULE = 'work-schedule',
}

export enum DIGITAL_SIGN_TAB {
  SIGNED_DOCUMENT = 'signed-document',
  MY_SIGN = 'my-sign',
}

export enum ACCOUNTING_MANAGEMENT_TAB {
  RECEIVABLES = 'receivables',
  SUPPLIERS = 'suppliers',
}

export type TBreadcrumb = {
  title: ReactNode;
  path?: string;
};

export type TRoute = {
  path: string;
  element: ReactNode;
  permissionKeys?: string[];
  breadcrumbs?:
    | TBreadcrumb[]
    | ((
        params: Record<string, string | undefined>,
        searchParams: URLSearchParams
      ) => TBreadcrumb[]);
};

export type TPageInfo = {
  pageTitle: string;
};

export type TPrivateRouteProps = {
  children: JSX.Element;
  route?: TRoute;
};
